<template>
    <div class="pageWarp">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle" backgroundColor="transparent"></Title-Box>


        <div class="content_box display_flex jus-c">
            <!-- 中间表单 -->
            <div class="g_form_box" v-if="detail">

                <div class="titleLine flex-row ite-c">
                    <span>分期账单信息</span>
                </div>
                <div class="border_box">
                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            订单号
                        </span>
                        <span class="flex_h_hC_vC row_value greenT">
                            {{detail.orderId}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            垫资状态
                        </span>
                        <span class="flex_h_hC_vC row_value"  :class="getStatusText(detail.status).cls">
                            {{getStatusText(detail.status).text}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            终端归属
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{detail.payeeName}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            权益分期账单（元）
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{detail.straightDownMoney | centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            收款方
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{detail.payeeName}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            收款金额（元）
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{detail.actualAmount | centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            付款时间
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{detail.paytime}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            付款方式
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{getPaymentTypeText(detail.paymentType)}}
                        </span>
                    </div>
                </div>
                <div class="titleLine flex-row ite-c">
                    <span>垫资信息</span>
                </div>
                <div class="border_box">
                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            垫资方名称
                        </span>
                        <span class="flex_h_hC_vC row_value greenT">
                            {{detail.payerName}}
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            垫资总金额
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{detail.actualAmount | centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            利率（年化）
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{detail.rates * 100}}%
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            总利息（元）
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
                            {{detail.interest | centsToYuan}}
                        </span>
                    </div>

                    <div class="form_row flex_h_hL_vC">
                        <span class="flex_h_hC_vC row_title">
                            每期利息
                        </span>
                        <span class="flex_h_hC_vC row_value orangeT">
<!--                            {{advanceFundInfo.interest}}-->
                        </span>

                        <span class="flex_h_hC_vC row_title">
                            还账信息
                        </span>
                        <span class="flex_h_hC_vC row_value">
                            {{detail.paidPeriods}}/{{detail.periods}}
                        </span>
                    </div>

                </div>

                <div class="flex-row jus-c" style="margin: 24px 0 31px;">
                    <button @click="goBack()" class="butStyle close_btn">关 闭</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
    import {getDetailAPI} from '@/api/ReducedFeeManage/reducedFeeManage';

    const paymentTypeMap = {
        '1': '转账'
    }

    const statusMap = {
        '-1': {text: '申请中', cls: 'grayT'},
        '0': {text: '待核销', cls: 'orangeT'},
        '1': {text: '未支付', cls: 'grayT'},
        '2': {text: '已支付', cls: 'lightGT'},
    }

    export default {
        components: {
            TitleBox
        },
        data() {
            return {
                //标题
                topTitle: {
                    title: '分期账单管理',
                    subTit: '分期账单详情'
                },
                detail: {},
                reducedInfo: {},
                advanceFundInfo: {},
                orderId: ''
            }
        },
        created() {
            this.orderId = this.$route.query.orderId;
            this.loadDetails();
        },
        methods: {
            getPaymentTypeText(val) {
                return paymentTypeMap[val]
            },
            getStatusText(val) {
                return statusMap[val]
            },
            async loadDetails() {
                const {data} = await getDetailAPI({orderId: this.orderId})
                console.log(data)
                this.detail = data.straightDownInfo
            },
            // 切换模块类型
            moduleLi(item, index) {
                this.moduleType.nowIndex = index;
                this.scrollIntoView(index);
            },
            // 把对应的模块内容滚动到可视区域
            scrollIntoView(index){
                document.querySelectorAll(".titleLine")[index].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            },
            // 关闭按钮-返回上一页
            goBack(){
                this.$router.go(-1);
            },


            // 表格类型切换-切换tabs表格
            tabLi(item, index) {
                // 0:'解冻明细', 1:'扣款明细'
                this.tabData.nowIndex = index;

                if(item == '解冻明细') {
                    this.getUnfrozenDataList()
                }
                else if(item == '扣款明细') {
                    this.getDeductionDataList()
                }

            },
            // 导出
            exportEvent() {
            },
            // 获取日志
        }
    }
</script>

<style lang="scss" scoped>
    .pageWarp {
        height: calc(100vh - 88px);
    }

    .greenT  {
        color: #2DBAA5 !important;
    }
    .lightGT {
        color: #76C819 !important;
    }
    .orangeT {
        color: #FA6241 !important;
    }
    .grayT {
        color: #B7B2AF !important;
    }
    .px18T {
        font-size: 18px;
    }

    .exportBtn {
        position: absolute;
        top: -38px;
        right: 5px;

        width: 72px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        border-radius: 4px;
        &:hover {
            background-color: rgb(247, 143, 120);
        }
    }

    .exportBtn .exportIcon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
        background-size: 14px 14px;
    }


    // 右边模块目录
    .right_menu {
        position: fixed;
        top: 118px;
        right: 20px;

        width: 144px;
        padding: 12px 12px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 7px;
        box-shadow: 0px 12px 24px rgba(0,0,0,0.05);

        z-index: 22;
    }
    .right_menu li {
        width: 120px;
        height: 32px;
        border-radius: 7px;
        background: #ffffff;
        color: #333333;
        font-size: 12px;
    }
    .right_menu li+li {
        margin-top: 1px;
    }
    .right_menu li.is_active,
    .right_menu li:hover {
        color: #ffffff;
        background: #FA6241;
    }


    .content_box {
        width: 100%;
        // min-width: calc( 144px + 144px + 900px );
        // min-width: 900px;
        min-width: calc( 144px + 900px );
        padding-right: 144px;
        box-sizing: border-box;
        margin-top: 2px;
        position: relative;
    }

    .g_form_box {
        width: 899px;
        // width: auto;
    }

    // 模块标题
    .g_form_box .titleLine {
        width: 100%;
        height: 16px;
        margin-top: 13px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .g_form_box .titleLine span {
        line-height: 16px;
        font-size: 12px;
        font-weight: bold;
        color: #2B2727;
    }

    .g_form_box .titleLine span::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 16px;
        margin-right: 6px;
        background: #FA6241;
        vertical-align: middle;
    }



    // 模块
    .g_form_box .border_box {
        width: 899px;
        margin-top: 13px;
        background: #EEEEEE;
        border: 1px solid #EEEEEE;
    }

    .g_form_box .form_row {
        width: auto;
        // min-width: 449px;
        height: 36px;
        min-height: 36px;
        // line-height: 36px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .g_form_box .form_row+.form_row {
        margin-top: 1px;
    }
    // .g_form_box .form_row.no_border {
    //     border-bottom: none;
    // }

    .g_form_box .form_row span+span {
        margin-left: 1px;
    }

    .g_form_box .form_row .row_title {
        width: 144px;
        height: 100%;
        background: #F5F5F5;
        color: #7F7F7F;
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // text-align: center;
    }

    .g_form_box .form_row .row_value {
        width: 304px;
        height: 100%;
        background: #FFFFFF;
        color: #333333;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }



    // 模块提示
    .g_form_box .tip_line {
        width: 100%;
        line-height: 16px;
        color: #7F7F7F;
        font-size: 12px;
        margin-top: 12px;
    }


    // 日志(时间线)
    .g_form_box .time_line_box {
        width: 100%;
        margin-top: 12px;
        color: #B7B2AF;
        font-size: 12px;
        background: #ffffff;
        padding: 16px 12px;
        box-sizing: border-box;
    }

    // 日志(表格)
    .g_form_box .table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 21px 21px;
        box-sizing: border-box;
    }


    // Tabs 标签页(标签页表格)
    .g_form_box .tabs_table_box {
        width: 100%;
        margin-top: 12px;
        background: #ffffff;
        padding: 10px 21px 21px;
        box-sizing: border-box;
    }

    /*表格切换*/
    .tabs_table_box .tabType {
        background: #fff;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #EEEEEE;
    }

    .tabType li {
        float: left;
        width: 80px;
        color: #7F7F7F;
        font-size: 12px;
        cursor: pointer;
        position: relative;
    }
    .tabType li:after {
        content: '';
        position: absolute;
        width: 80px;
        height: 4px;
        background: transparent;
        bottom: -4px;
        left: 0;
    }

    .tabType li.on {
        color: #FA6241;
    }
    .tabType li.on:after {
        background: #FA6241;
    }

    .tabs_table_box .table_bottom {
        // height: 24px;
        // height: 16px;
        font-size: 12px;
        font-weight:400;
        line-height: 16px;
        // line-height: 24px;
        color: #2B2727;
        margin-top: 20px;
        background: #fff;
        // background: rgb(199, 148, 148);
    }
    .tabs_table_box .table_bottom span {
        height: 100%;
    }
    .tabs_table_box .table_bottom span.px18T {
        height: 100%;
        line-height: 18px;
    }



    // 关闭按钮
    .close_btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-radius: 4px;
        background: #FFFFFF;
        color: #2B2727;
        color: #666666;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        &:hover {
            // background-color: #f1f1f1;
            border: 1px solid #d1d0d0;
        }
    }
</style>

